import { logError } from '@ecomm/error-handling'
import { useEffect, useState } from 'react'
import { requestLiveChatAvailability } from '../requestLiveChatAvailability'

import { salesChatAppId } from '../chatAppId'

/**
 * @returns whether live chat is enabled and agents are available
 *
 * Hard-coded to sales chat experience.
 */
export const useLiveChatAvailability = () => {
  const [hasAvailableAgents, setHasAvailableAgents] = useState(false)
  useEffect(() => {
    const handleFailure = () => {
      setHasAvailableAgents(false)
    }
    const handleSuccess = (response: boolean) => {
      setHasAvailableAgents(response)
    }

    requestLiveChatAvailability(
      salesChatAppId,
      handleFailure,
      handleSuccess
    ).catch(logError)
  }, [])

  return hasAvailableAgents
}
